module.exports = __webpack_public_path__ + "img/it.f6f9394d.png";